import React from 'react'
import moment from 'moment'
import { Camelized } from 'humps'
import { AvailabilitySlot } from '@dialogue/timekeeper'

import { selectProvider } from 'APP/Store/ProviderBooking/selectors'
import { useSelector } from 'APP/Hooks/redux'
import { getPractitionerRoleLabel } from 'APP/Lib/PractitionerHelpers'

import AppointmentCardStatic from 'APP/Components/AppointmentCard/AppointmentCardStatic'

export interface AppointmentCheckoutItemProps {
  availabilitySlot: Camelized<AvailabilitySlot>
}

export const AppointmentCheckoutItem = ({ availabilitySlot }: AppointmentCheckoutItemProps) => {
  const providerInfo = useSelector((s) => selectProvider(s, availabilitySlot.providerId))
  const providerRole = getPractitionerRoleLabel(providerInfo.licenses, providerInfo.jobTitle)

  return (
    <AppointmentCardStatic
      date={availabilitySlot.startAt}
      timeslot={`${moment(availabilitySlot.startAt).format('h:mm A')} - ${moment(
        availabilitySlot.endAt
      ).format('h:mm A')}`}
      icon={providerInfo.picture}
      providerName={`${providerInfo.givenName} ${providerInfo.familyName}`}
      providerRole={providerRole}
    />
  )
}
